export { SectionTabs } from './SectionTabs';
export { TabAccordion } from './TabAccordion';
export { TabUsps } from './TabUsps';
export { TabTextWithImage } from './TabTextWithImage';
export { TabVideo } from './TabVideo';
